import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  onSnapshot,
  setDoc,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";
import { app } from "../../config/config";
import { REF } from "../ref";
import { TYPES } from "./payout_status.type";

const firestore = getFirestore(app);

let payoutStatusSub = null;

export const snapPayoutStatus =
  ({ periodStart }) =>
  (dispatch) => {
    if (payoutStatusSub) {
      payoutStatusSub();
      payoutStatusSub = null;
    }
    dispatch({ type: TYPES.GET_PAYOUT_STATUS_REQUEST });
    const q = query(
      collection(firestore, REF.PAYOUT_STATUS),
      where("periodStart", "==", periodStart),
    );
    payoutStatusSub = onSnapshot(q, (snapshot) => {
      const records = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
      dispatch({ type: TYPES.GET_PAYOUT_STATUS_SUCCESS, payload: records });
    });
  };

export const unSnapPayoutStatus = () => () => {
  if (payoutStatusSub) {
    payoutStatusSub();
    payoutStatusSub = null;
  }
};

export const markPayoutComplete =
  ({ data }) =>
  async () => {
    const docId = `${data.staff}_${data.periodStart}`;
    const timestamp = serverTimestamp();
    await setDoc(
      doc(firestore, REF.PAYOUT_STATUS, docId),
      {
        ...data,
        paid: true,
        paidAt: timestamp,
        createAt: timestamp,
        updateAt: timestamp,
      },
      { merge: true },
    );
    await addDoc(collection(firestore, REF.PAYOUT_HISTORY), {
      ...data,
      action: "tick",
      createAt: serverTimestamp(),
    });
  };

export const markPayoutUncomplete =
  ({ staffId, periodStart, periodEnd, actionBy }) =>
  async () => {
    const docId = `${staffId}_${periodStart}`;
    const timestamp = serverTimestamp();
    await setDoc(
      doc(firestore, REF.PAYOUT_STATUS, docId),
      { paid: false, paidAt: null, updateAt: timestamp },
      { merge: true },
    );
    await addDoc(collection(firestore, REF.PAYOUT_HISTORY), {
      staff: staffId,
      periodStart,
      periodEnd,
      action: "untick",
      actionBy: actionBy || null,
      createAt: serverTimestamp(),
    });
  };
